<template>
  <div class="crew-summary-alert-tooltip">
    <div class="alert-description">{{ description }}</div>
    <div v-for="alert in alertInfo" :key="alert.id">
      <!-- アイコン + サマリーメッセージ横並び -->
      <div class="alert-summary-row flex items-start">
        <span
          class="material-icons alert-summary-icon"
          :class="{
            warning: isWarning(alert),
            caution: isCaution(alert),
          }"
        >
          error
        </span>
        <span class="alert-summary">
          {{ alert.message_summary }}
        </span>
      </div>

      <!-- 船舶名と上位職（最大９行、10件以上は末尾に「...」） -->
      <div
        class="alert-crew-summary-row"
        v-for="(detail, i) in visibleDetails(alert.message_details)"
        :key="i"
      >
        <template v-if="detail === 'ellipsis'">
          <span class="vessel-name">・・・</span>
        </template>
        <template v-else>
          <span class="vessel-name">{{ detail.msg1 }}</span>
          <span class="crew-name">
            {{ detail.msg2[0] }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TooltipCrewSummaryAlert",
  props: {
    alertInfo: {
      type: Array,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  methods: {
    isWarning(alert) {
      return alert.alert_type === "WARNING";
    },
    isCaution(alert) {
      return alert.alert_type === "CAUTION";
    },
    visibleDetails(details) {
      const count = details.length;
      if (count > 10) {
        // 10件以上 → 最初の9件 + "ellipsis"
        return [...details.slice(0, 9), "ellipsis"];
      }
      // 10件以下 → すべて表示
      return details;
    },
  },
};
</script>
<style lang="scss">
.crew-summary-alert-tooltip {
  // レイアウト指定
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem 0.625rem 0.75rem;

  // タイポグラフィ共通
  color: #fff;
  font-size: 0.75rem; // 12px
  font-style: normal;
  font-weight: 300; // 全体デフォルト
  line-height: 1.125rem; // 18px

  .alert-title {
    font-size: 0.75rem;
    white-space: pre-line;
  }

  .alert-details {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .alert-summary-icon {
    display: flex;
    width: 1rem;
    height: 1rem;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1 / 1;
    font-size: 1rem;

    margin-right: 6px;
    flex-shrink: 0;
    &.warning {
      color: #e02e22;
    }
    &.caution {
      color: #ffd400;
    }
  }

  .alert-crew-summary-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    gap: 0.5rem;
  }

  .vessel-name {
    width: 8.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .crew-name {
    width: 4.75rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
